import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { debugLog } from './utils/debug';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA capabilities (static assets only)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        debugLog('SW registered: ', registration);
      })
      .catch((registrationError) => {
        debugLog('SW registration failed: ', registrationError);
      });
  });
} else if ('serviceWorker' in navigator && process.env.NODE_ENV !== 'production') {
  // Unregister any existing service workers in development to prevent reload loops
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
    }
  });
}
